import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateWebhookMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  input: Types.UpdateWebhookInput;
}>;

export type UpdateWebhookMutation = {
  __typename?: 'Mutation';
  updateWebhook: {
    __typename?: 'Webhook';
    id: any;
    ownerUserId?: any | null;
    ownerTeamId?: any | null;
    type: Types.WebhookType;
    label: string;
    url: string;
    method: string;
    createdAt: any;
  };
};

export const UpdateWebhookDocument = gql`
  mutation UpdateWebhook($id: UUID!, $input: UpdateWebhookInput!) {
    updateWebhook(id: $id, input: $input) {
      id
      ownerUserId
      ownerTeamId
      type
      label
      url
      method
      createdAt
    }
  }
`;
export type UpdateWebhookMutationFn = Apollo.MutationFunction<
  UpdateWebhookMutation,
  UpdateWebhookMutationVariables
>;

/**
 * __useUpdateWebhookMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookMutation, { data, loading, error }] = useUpdateWebhookMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebhookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWebhookMutation,
    UpdateWebhookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWebhookMutation,
    UpdateWebhookMutationVariables
  >(UpdateWebhookDocument, options);
}
export type UpdateWebhookMutationHookResult = ReturnType<
  typeof useUpdateWebhookMutation
>;
export type UpdateWebhookMutationResult =
  Apollo.MutationResult<UpdateWebhookMutation>;
export type UpdateWebhookMutationOptions = Apollo.BaseMutationOptions<
  UpdateWebhookMutation,
  UpdateWebhookMutationVariables
>;
